import React , { Component } from 'react';
import LocaleStore from '../../store/LocaleStore';
import {injectIntl} from 'react-intl';

import { changeLocale } from '../../actions/';

import Radium from 'radium';
import Helpable from '../Helpable';

const localeButton = {

  buttonWrap: {
  width: "90px",
  cursor: "pointer"
  },
  buttonBg: {
    backgroundColor: 'rgba(23, 93, 132, 0.85)',
    borderRadius: "20px",
    color:"#fff",
    transition:"all 0.2s ease"
  },
  buttonSwitch: {
    base: {
      position:'relative',
      left:'0px',
      width: '33px',
      height: '33px',
      border:'solid 3px',
      borderRadius: '20px',
      transition:'all 0.2s ease'
    },
    active: {
      left:'54px'
    }
  },
  buttonEN: {
    base: {
      position:'absolute',
      transition:'all 0.2s ease',
      paddingTop:'4px',
      fontSize:'130%',
      textTransform:'uppercase',
      fontWeight:'bold',
      marginLeft:'60px'
    },
    active: {
    }
  },

  buttonIT: {
    base: {
      position:'absolute',
      transition:'all 0.2s ease',
      paddingTop:'4px',
      fontSize:'130%',
      textTransform:'uppercase',
      fontWeight:'bold',
      marginLeft:'10px'
    },
    active: {
    }
  }
}


class LanguageSwitcher extends Component {
    constructor(props) {
      super(props);
        this.handleToggle = this.handleToggle.bind(this);
    }

    getLocaleFromStore() {
      return LocaleStore.getLocale();
    }

    handleToggle() {
      const locale = this.getLocaleFromStore();
      let changedLocale = ((locale === 'it')?'en':'it');

      changeLocale(changedLocale);
    }

    render() {

      let isITLocale = ( this.getLocaleFromStore() ==='it' );

      const toggleStyle = (isITLocale?[localeButton.buttonSwitch.base]:[localeButton.buttonSwitch.base, localeButton.buttonSwitch.active]);

      return (
        <ul className="nav navbar-nav navbar-right" style={ { marginRight: "initial", marginTop:'10px'}}>
          <li>
            <Helpable bind="languageSwitcher" iconPosition="bottom center"
                      buttonStyle={{cursor:'ponter', color:'white'}} guideRef="languageSwitcher.guide" attachment="top right">

            <div id="languageSwitcher" style={localeButton.buttonWrap} onClick={this.handleToggle}>
              <div style={localeButton.buttonBg}>
                <div style={localeButton.buttonIT.base}>IT</div>
                <div style={localeButton.buttonEN.base}>EN</div>
                <div style={toggleStyle}></div>
              </div>
            </div>

          </Helpable>
        </li>
      </ul>
    )
    }
}

export default injectIntl(Radium(LanguageSwitcher));



// WEBPACK FOOTER //
// ./src/components/Header/LanguageSwitcher.js